module.exports = __webpack_public_path__ + "static/media/HardeevilleRVRulesRegulations-2026-revised.d962c3cb.pdf";